import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
// TODO make this a styled component

const Switch = styled.div`
  position: relative;
  width: 40px;
  height: 20px;
  background: #777;
  border-radius: 22px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    top: 50%;
    left: 3px;
    background: #333;
    transform: translate(0, -50%);
  }
`

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`

const Input = styled.input`
  opacity: 0;
  position: absolute;

  &:checked + ${Switch} {
    background: ${(props) => props.theme.colours.active};
    &:before {
      transform: translate(17px, -50%);
    }
  }
`
/*
Toggle Switch Component
Usage: <ToggleSwitch id="id" checked={value} onChange={checked => setValue(checked)}} />
*/
const ToggleSwitch = ({
  id,
  checked = false,
  handleChange,
  disabled = false,
}) => {
  return (
    <Label>
      <Input
        id={id}
        checked={checked}
        disabled={disabled}
        type="checkbox"
        onChange={(e) => handleChange(e.target.checked)}
      />
      <Switch />
    </Label>
  )
}

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default ToggleSwitch
